import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  setCarBookmark as onSetCarBookmark
} from './../../actions/setCarBookmarkActions'

const mapStateToProps = (state) => ({
  dataStateSetCarBookmark: state.setCarBookmark.dataState,
  errorsSetCarBookmark: get(state, ['setCarBookmark', 'errors', 'data', null])
})

const mapDispatchToProps = {
  onSetCarBookmark
}

const withSetCarBookmark = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withSetCarBookmark }